import React from 'react'
import { useHistory } from 'react-router-dom';
import { ImageUrl } from '../../../utils/ImageUrl'
import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../reduxToolkit/rootReducer';
import { ROUTE_CONSTANTS_VERSION_0 } from '../../../version-0/src/constants/RouteConstants';
import { ROUTE_CONSTANTS } from '../../../constants/RouteConstants';
import History from '../../../customHistory';
import { resetSidenav } from '../../../reduxToolkit/sidenavSlice/sidenavSlice';

interface ErrorBoundaryContentProps {
  errorType?: any;
  errorMessage?: any;
  firstLineErrorContent?: any;
  secondLineErrorContent?: any;
}
function ErrorBoundaryContent(props: ErrorBoundaryContentProps) {
  const dispatch = useDispatch()
  const { isProjectListOpen, selectedProjectData } = useSelector((state: RootState) => state.ProjectModalData);
  const history = History;
  const handleHomeButtonClick = () => {
    if (selectedProjectData != null) {
      if (selectedProjectData?.name == "Version-0" && selectedProjectData?.type == "Data Nexus") {
        dispatch(resetSidenav())
        history.push(ROUTE_CONSTANTS_VERSION_0.Dashboard,selectedProjectData?.id)
        window.location.reload();
        return;
      }
      dispatch(resetSidenav())
      history.push(ROUTE_CONSTANTS.LAYOUT,selectedProjectData?.id)
      window.location.reload();
    }
  }
  return (
    <>
      <div className="errorheaderlogoErrorBoundary">
        <div className="mainlogo" style={{
          background: 'black',
          width: '215px',
          height: '46px',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          paddingLeft: '10px',
        }}>
          <img src={ImageUrl.Logo} />
        </div>
      </div>
      <div className="mainErrorDetailsErrorBoundary" style={{
        height: 'calc(100vh - 46px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: ' #ffffff',
        flexDirection: 'column'
      }}>
        <div className="errorimageContent">
          <img src={props?.errorType == '404' ? ImageUrl.Error404 : props?.errorType == '500' ? ImageUrl.Error500 : ImageUrl.Error404} alt="404" style={{ height: '76%' }} />
        </div>
        {props?.errorMessage ? <h4 style={{ marginBottom: '20px', fontWeight: '500', fontSize: '28px' }}>{props?.errorMessage}</h4> : null}
        <p style={{ marginBottom: '20px', fontWeight: '400', fontSize: '14px', textAlign: 'center' }}>
          {props?.firstLineErrorContent ? <span style={{ display: 'block' }}>{props?.firstLineErrorContent}</span> : null}
          {props?.secondLineErrorContent ? <span style={{ display: 'block' }}>{props?.secondLineErrorContent}</span> : null}
        </p>
        <div className="backtoHomeBtnErrorBoundary">
          <Button
            style={{
              color: "black",
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '20px',
              fontWeight: '600',
              height: '40px'
            }}
            type="primary"
            htmlType="submit"
            onClick={handleHomeButtonClick}
          >
            <span style={{ padding: '2px 10px' }}>Back to homepage</span>
          </Button>
        </div>
      </div>
    </>
  )
}

export default ErrorBoundaryContent
